import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const MetaMilestone: ITypeSpecificPolicy<types.MetaMilestone> = {
  fields: {
    createdAt: dateTimeFieldPolicy(),
    milestoneUpdated: dateTimeFieldPolicy()
  }
};
